export default {
  LIST(state, data) {
    state.checkMonitoring = data
  },
  GET(state, data) {
    state.checkMonitoring = data
  },
  UPDATE(state, value) {
    state.checkMonitoring = {
      id: value.id,
      apply_doc: value.apply_doc.id,
      status: value.status,
      comment: value.status,
    }
  },
  FRESH(state) {
    state.checkMonitoring = {
      id: null,
      apply_doc: null,
      status: null,
      comment: null,
    }
  },
}
